window.App.whenReady( _ => {
    $( '.js-menu-mobile-button' ).on( 'click', e => {
        window.App.$html.toggleClass( '__menu-open' );
    } );

    $( '.js-submenu-link' ).on( 'click', e => {
        e.preventDefault();

        $( e.currentTarget )
            .next( '.js-submenu' )
            .slideToggle( 300 )
            .end()
            .parent()
            .toggleClass( '__open' );
    } );
} );



// WEBPACK FOOTER //
// ./resources/js/modules/menu-mobile.js